var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 24,
    viewBox: "0 0 39 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.25C1.0335 0.25 0.25 1.0335 0.25 2C0.25 2.9665 1.0335 3.75 2 3.75V0.25ZM37 3.75C37.9665 3.75 38.75 2.9665 38.75 2C38.75 1.0335 37.9665 0.25 37 0.25V3.75ZM2 10.25C1.0335 10.25 0.25 11.0335 0.25 12C0.25 12.9665 1.0335 13.75 2 13.75V10.25ZM32 13.75C32.9665 13.75 33.75 12.9665 33.75 12C33.75 11.0335 32.9665 10.25 32 10.25V13.75ZM2 20.25C1.0335 20.25 0.25 21.0335 0.25 22C0.25 22.9665 1.0335 23.75 2 23.75V20.25ZM19.5 23.75C20.4665 23.75 21.25 22.9665 21.25 22C21.25 21.0335 20.4665 20.25 19.5 20.25V23.75ZM2 3.75H37V0.25H2V3.75ZM2 13.75H32V10.25H2V13.75ZM2 23.75H19.5V20.25H2V23.75Z",
    fill: "#5C5E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.87739787c7dca2bc04e6804dff38eeb5.svg";
export { ForwardRef as ReactComponent };